import { message } from 'antd'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import store from 'store'
import Xhr from 'xmov-lib/utils/xhr'

const ignoredPaths = (url: string | undefined) => !!url ? /(login|rsa|captcha)/.test(url) : false

const requestInterceptors = (cfg: AxiosRequestConfig) => {
  const { url, headers } = cfg
  if (ignoredPaths(url)) {
    return cfg
  }
  const user = store.appStore.user
  if (!!user && !!headers) {
    headers.Authorization = `token ${user.user_id} ${user.key}`
  }
  return cfg
}

const responseInterceptors = (response: AxiosResponse) => {
  const { data, status, config } = response
  if (status === 200 || 400) {
    const err1 = data.hasOwnProperty('error_code') && data.error_code !== 0
    const err2 = data.hasOwnProperty('message') && data.message !== 'ok'
    const err3 = !data.hasOwnProperty('error_code') && (data.hasOwnProperty('error_reason') || data.hasOwnProperty('error_message'))
    const err = err1 || err2 || err3
    if (err) {
      const err = data.error_reason.toString()
      message.error(err)
      console.error(err + '：' + config.url)
      response.data = {
        ok: false,
        data: null,
        msg: data.error_reason || data.error_message,
      };
    } else {
      response.data = {
        ok: true,
        data: data.hasOwnProperty('data') ? data.data : data,
        msg: null,
      };
    }
  }
  if (status === 401) {
    window.location.href = '/login'
  }
  return response
}

export default function getInstance() {
  return new Xhr(
    {
      // @ts-ignore
      baseURL: window.EndPoint,
    },
    {
      requestInterceptors,
      responseInterceptors,
    }
  )
}
